// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__womHp","container-dark":"Dashboard_container-dark__4OVYs"};